import request from "../utils/request.js"

// 获取七牛token
// export function getQiNiuToken() {
//     return request({
//         url: "/resources/getToken",
//         method: "get"
//     })
// }
// 新增授权书
export function savePowerOfAttorneyApi(params) {
    return request({
        url: "/powerOfAttorney/save/",
        method: "post",
        data: params,
    })
}
// 新增林木采伐现场勘验表
export function treesHarvestingSceneCheckSaveApi(params) {
    return request({
        url: "/treesHarvestingSceneCheck/save",
        method: "post",
        data: params,
    })
}

// 新增农村土地出租合同
export function villageLandManagementAllSaveApi(params) {
    return request({
        url: "/villageLandManagementAll/save",
        method: "post",
        data: params,
    })
}

// 新增农村土地入股合同
export function villageLandManagementSharesAllSaveApi(params) {
    return request({
        url: "/villageLandManagementSharesAll/save",
        method: "post",
        data: params,
    })
}

// 新增投保用户
export function addUserInsureApi(params) {
    return request({
        url: "/UserInsure/addUserInsure",
        method: "post",
        data: params,
    })
}
// 新增贷款用户
export function addUserLoanApi(params) {
    return request({
        url: "/UserLoan/addUserLoan",
        method: "post",
        data: params,
    })
}

// 新增报灾信息
export function theDisasterAddApi(params) {
    return request({
        url: "/theDisaster/add",
        method: "post",
        data: params,
    })
}

// 补贴查询
export function querySubsidyObjectApi(params) {
    return request({
        url: "/querySubsidy/queryObject?" + params,
        method: "get"
    })
}

// 新增林木采伐申请表
export function treesHarvestingApplySaveApi(params) {
    return request({
        url: "/treesHarvestingApply/save",
        method: "post",
        data: params,
    })
}
